import { MatLegacySnackBarRef as MatSnackBarRef, LegacyTextOnlySnackBar as TextOnlySnackBar } from '@angular/material/legacy-snack-bar';

export class PendingUndoableOperation<TState, TCompletion = any> {
  private completionPromise: Promise<TCompletion>;
  private resolveCompletion: (value: TCompletion | PromiseLike<TCompletion>) => void;
  private rejectCompletion: (reason?: any) => void;
  private tookAction = false;

  constructor(
    private state: TState,
    private undoOperation: (state: TState) => TCompletion | PromiseLike<TCompletion>,
    private commitOperation: (state: TState) => TCompletion | PromiseLike<TCompletion>,
    private snackBarRef: MatSnackBarRef<TextOnlySnackBar>,
  ) {
    this.resolveCompletion = () => { throw new Error('this should be unreachable'); };
    this.rejectCompletion = () => { throw new Error('this should be unreachable'); };
    this.completionPromise = new Promise<TCompletion>((resolve, reject) => {
      this.resolveCompletion = resolve;
      this.rejectCompletion = reject;
    });

    snackBarRef.onAction().subscribe(
      () => {
        this.onUndo();
      },
      (error: unknown) => {
        this.handleError(error);
      },
    );
    snackBarRef.afterDismissed().subscribe(
      () => {
        this.onCommit();
      },
      (error: unknown) => {
        this.handleError(error);
      },
    );
  }

  private handleError(error: unknown) {
    const ignoreAction = this.shouldIgnoreAction();
    this.snackBarRef.dismiss();

    if (!ignoreAction) {
      this.rejectCompletion(error);
    } else {
      throw error;
    }
  }

  private shouldIgnoreAction(): boolean {
    if (this.tookAction) {
      return true;
    }

    this.tookAction = true;
    return false;
  }

  private onCommit(): void {
    if (!this.shouldIgnoreAction()) {
      this.resolveCompletion(this.commitOperation(this.state));
    }
  }

  private onUndo(): void {
    if (!this.shouldIgnoreAction()) {
      this.resolveCompletion(this.undoOperation(this.state));
    }
  }

  commit(): void {
    this.onCommit();
    this.snackBarRef.dismiss();
  }

  undo(): void {
    this.onUndo();
    this.snackBarRef.dismiss();
  }

  onCompleted(): Promise<TCompletion> {
    return this.completionPromise;
  }
}
